import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useLocation, useHistory } from "react-router-dom";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { toastr } from "react-redux-toastr";
import humburger from "../../assets/images/humburger.png";
import sendButtonImg from "../../assets/images/send-chat-button.png";
import {
    addRiskRegister,
    approveReview,
    rejectReview,
    riskRegisterQuestionById,
    uploadImageInChat
} from "../../actions/riskManagement";
import { useWebSocket } from '../WebSocket/useWebSocket';

const RiskRegisterChat = () => {
    const { _id } = useParams();
    const { _categoryId } = useParams();
    const { _questionId } = useParams();
    const { assigneeOrganisationId } = useParams();

    // get riskid from url
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const riskid = queryParams.get("riskid");

    const dispatch = useDispatch();
    const history = useHistory();
    const id = useSelector((state) => state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id);
    const showDetails = useSelector((state) => state?.riskManagement?.riskRegisterById?.data || []);
    const idAssignee = useSelector((state) => state?.riskManagement?.riskRegisterById || []);
    const [isModal, setModal] = useState("");
    const [isModalData, setModalData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(1);
    const [messageInput, setMessageInput] = useState('');
    const [registerFor, setRegisterFor] = useState("forever");
    const [riskLevel, setRiskLevel] = useState("low");
    const [questionId, setQuestionId] = useState("");
    const [categoryId, setCategoryId] = useState("");
    const [riskNote, setRiskNote] = useState("");
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    // const [assigneeOrganisationId, setAssigneeOrganisationId] = useState("");
    const [fileSent, setFileSent] = useState("");
    const [chatData, setChatData] = useState([]);
    const {
        messageAll,
        sendMessage,
        getMessages
    } = useWebSocket({
        userId: _id,
        orgId: id
    });
    const [isChatMinimized, setIsChatMinimized] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [modalType, setModalType] = useState(null); // 'accept' or 'reject'
    const [riskComment, setRiskComment] = useState('');
    const [enlargedImage, setEnlargedImage] = useState(null);
    const [showChat, setShowChat] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('files', file);

        uploadImageInChat(formData)
            .then(response => {
                setFileSent(response);
                setSelectedFile(file);
            })
            .catch(error => {
                // console.error removed
            });
    };

    const sendMessages = () => {
        if (messageInput == "") {
            toastr.error("Please enter the message.");
            return
        }
        sendMessage({
            messageText: messageInput,
            questionFormId: _id,
            questionCategoryId: _categoryId,
            questionId: _questionId,
            toOrganisationId: assigneeOrganisationId,
            ...(fileSent?.data && {
                attachedFiles: fileSent?.data
            })
        });
        setMessageInput("");
        setFileSent("");
        setSelectedFile("");
        const chatContainer = document.querySelector('.chatBoxMain');
        chatContainer.scrollTop = chatContainer.scrollHeight;
    };

    useEffect(() => {
        setTimeout(() => {
            if (id) {
                getMessages({
                    organisationId: id,
                    questionCategoryId: _categoryId,
                    questionFormId: _id,
                    questionId: _questionId
                });
            }
        }, [1000])
    }, [id, _categoryId, _id, _questionId])


    useEffect(() => {
        const chatContainer = document.querySelector('.chatBoxMain');
        if (chatContainer && messageAll?.length > 0) {
            chatContainer.scrollTop = chatContainer.scrollHeight;
        }
    }, [messageAll]);

    const chatOpenBox = async (categoryName, question, categoryId) => {
        getMessages({
            organisationId: id,
            questionCategoryId: categoryId,
            questionFormId: _id,
            questionId: question?.id
        });
        setCategoryId(categoryId);
        setQuestionId(question?.id);
        setChatData([categoryName, question, categoryId]);
        setIsChatMinimized(false);
        setShowChat(true);
    };

    useEffect(() => {
        if (id && _id && _categoryId && _questionId) {
            riskRegisterQuestionById(id, dispatch, _id, _categoryId, _questionId)
        }
    }, [id, _id, _categoryId, _questionId])


    // Action handlers
    const handleRouteChange = () => history.push('/tprm/risk-register');
    const approveBtn = () => approveReview(id, _id, [], handleRouteChange);
    const rejectBtn = () => rejectReview(id, _id, [], handleRouteChange);
    const openModal = () => setModal("Form Wizard modal risk");
    const closeModal = () => {
        setModal("");
    }

    const saveRisk = () => {
        if (registerFor == "") {
            toastr.error("Register For is required")
            return
        }
        if (riskLevel == "") {
            toastr.error("Risk Level is required")
            return
        }
        if (riskNote == "") {
            toastr.error("Comment is required")
            return
        }
        let data = {
            categoryId,
            questionId,
            riskNote,
            riskLevel,
            registerFor
        }
        addRiskRegister(id, _id, data, dispatch, closeModal)
    }

    const handleConfirmAction = () => {
        if (!riskComment.trim()) {
            toastr.error("Please provide a comment");
            return;
        }

        if (modalType === 'accept') {
            approveReview(id, _id, { comment: riskComment, riskId: riskid }, handleRouteChange);
        } else if (modalType === 'reject') {
            rejectReview(id, _id, { comment: riskComment, riskId: riskid }, handleRouteChange);
        }
        setShowConfirmModal(false);
        setRiskComment('');
        setModalType(null);
    };

    const openConfirmModal = (type) => {
        setModalType(type);
        setShowConfirmModal(true);
    };

    return (
        <div className="container-fluid risk-dashboard">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1 className="welcome-text">Third Party Risk Management</h1>
                        <nav aria-label="breadcrumb" className="mt-1">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/risk-register-vendor" className="welcome-textSmall">
                                        Third Party Risk Management
                                    </Link>
                                    &nbsp;/&nbsp;
                                    <Link to="/tprm/risk-register" className="welcome-textSmall">
                                        Risk Register
                                    </Link>
                                    &nbsp;/&nbsp;Details
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="body">
                    <div>
                        <div className="group-box p-0 border-none">
                            <div>
                                <div className="d-flex">
                                    <div className="card" style={{
                                        width: '65%',
                                        border: '1px solid #3d3c3c',
                                        transition: 'width 0.3s ease'
                                    }}>
                                        {/* Action Button - Moved to top */}
                                        <div className="d-flex align-items-center justify-content-end p-3" style={{ 
                                            borderBottom: '1px solid #eee',
                                            backgroundColor: '#f8f9fa'
                                        }}>
                                            <button
                                                onClick={() => openConfirmModal('reject')}
                                                className="btn btn-danger"
                                                style={{
                                                    padding: '8px 24px',
                                                    borderRadius: '6px',
                                                    border: 'none',
                                                    backgroundColor: '#dc3545',
                                                    color: '#ffffff',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s ease',
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    boxShadow: '0 2px 4px rgba(220, 53, 69, 0.2)'
                                                }}
                                            >
                                                <i className="fa fa-times-circle"></i>
                                                Close Risk
                                            </button>
                                        </div>

                                        <div className="dataTables_paginate ml-2 d-flex justify-content-between align-items-center">
                                            <div className="action-buttons" style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                width: '100%',
                                                padding: '16px',
                                            }}>
                                                <div className="risk-details mb-3">
                                                    <div className="card" style={{ border: '1px solid #eee', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                                                        <div className="card-body p-4">
                                                            <div className="d-flex justify-content-between align-items-center mb-4">
                                                                <h5 className="card-title mb-0" style={{ fontWeight: '600', color: '#2c3e50' }}>
                                                                    Risk Details
                                                                </h5>
                                                                <span className={`badge ${showDetails[0]?.riskRegister?.status === "open" ? "badge-danger" : "badge-success"}`} 
                                                                    style={{ 
                                                                        padding: '6px 12px',
                                                                        fontSize: '12px',
                                                                        fontWeight: '500',
                                                                        borderRadius: '4px'
                                                                    }}>
                                                                    {showDetails[0]?.riskRegister?.status?.toUpperCase() || "UNKNOWN"}
                                                                </span>
                                                            </div>
                                                            
                                                            <div className="row">
                                                                <div className="col-md-6 mb-3">
                                                                    <div className="risk-info-item">
                                                                        <label style={{ fontSize: '13px', color: '#6c757d', marginBottom: '4px' }}>Title</label>
                                                                        <p style={{ fontSize: '15px', fontWeight: '500', color: '#2c3e50', margin: 0 }}>
                                                                            {showDetails[0]?.riskRegister?.title || "N/A"}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div className="col-md-6 mb-3">
                                                                    <div className="risk-info-item">
                                                                        <label style={{ fontSize: '13px', color: '#6c757d', marginBottom: '4px' }}>Risk Level</label>
                                                                        <span className={`badge ${showDetails[0]?.riskRegister?.riskLevel === "high" ? "badge-danger" : 
                                                                            showDetails[0]?.riskRegister?.riskLevel === "medium" ? "badge-warning" : "badge-info"}`}
                                                                            style={{ 
                                                                                padding: '6px 12px',
                                                                                fontSize: '12px',
                                                                                fontWeight: '500',
                                                                                borderRadius: '4px'
                                                                            }}>
                                                                            {showDetails[0]?.riskRegister?.riskLevel?.toUpperCase() || "UNKNOWN"}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 mb-3">
                                                                    <div className="risk-info-item">
                                                                        <label style={{ fontSize: '13px', color: '#6c757d', marginBottom: '4px' }}>Assigned To</label>
                                                                        <p style={{ fontSize: '15px', color: '#2c3e50', margin: 0 }}>
                                                                            {showDetails[0]?.riskRegister?.assigneeOrganisationName || "N/A"}
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 mb-3">
                                                                    <div className="risk-info-item">
                                                                        <label style={{ fontSize: '13px', color: '#6c757d', marginBottom: '4px' }}>Category</label>
                                                                        <p style={{ fontSize: '15px', color: '#2c3e50', margin: 0 }}>
                                                                            {showDetails[0]?.category?.categoryName || "N/A"}
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div className="col-12 mb-3">
                                                                    <div className="risk-info-item">
                                                                        <label style={{ fontSize: '13px', color: '#6c757d', marginBottom: '4px' }}>Description</label>
                                                                        <p style={{ 
                                                                            fontSize: '14px', 
                                                                            color: '#2c3e50', 
                                                                            margin: 0,
                                                                            lineHeight: '1.6',
                                                                            backgroundColor: '#f8f9fa',
                                                                            padding: '12px',
                                                                            borderRadius: '6px',
                                                                            border: '1px solid #e9ecef'
                                                                        }}>
                                                                            {showDetails[0]?.riskRegister?.riskNote || "No description provided"}
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div className="col-12">
                                                                    <div className="risk-info-item">
                                                                        <label style={{ fontSize: '13px', color: '#6c757d', marginBottom: '4px' }}>Recommendation</label>
                                                                        <p style={{ 
                                                                            fontSize: '14px', 
                                                                            color: '#2c3e50', 
                                                                            margin: 0,
                                                                            lineHeight: '1.6',
                                                                            backgroundColor: '#f8f9fa',
                                                                            padding: '12px',
                                                                            borderRadius: '6px',
                                                                            border: '1px solid #e9ecef'
                                                                        }}>
                                                                            {showDetails[0]?.question?.riskAnalysis?.recomendation || "No recommendations provided"}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <Accordion defaultExpanded>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls={`panel-content`}
                                                        id={`panel-header`}
                                                        style={{
                                                            backgroundColor: '#f8f9fa',
                                                            borderBottom: '1px solid #eee'
                                                        }}
                                                    >
                                                        <div className="d-flex align-items-center justify-content-between w-100">
                                                            <span style={{ fontWeight: '500', color: '#2c3e50' }}>
                                                                {showDetails[0]?.category?.categoryName}
                                                            </span>
                                                            <span className="badge badge-primary" style={{ 
                                                                padding: '4px 8px',
                                                                fontSize: '12px',
                                                                backgroundColor: '#e3f2fd',
                                                                color: '#1976d2'
                                                            }}>
                                                                {showDetails?.length} Questions
                                                            </span>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <div className="boxAccordian">
                                                            {showDetails?.map((item, qIndex) => (
                                                                <div key={qIndex} className="mb-4" style={{
                                                                    border: '1px solid #eee',
                                                                    borderRadius: '8px',
                                                                    padding: '16px',
                                                                    backgroundColor: '#fff'
                                                                }}>
                                                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                                                        <div style={{ flex: 1 }}>
                                                                            <h6 style={{ 
                                                                                fontSize: '15px', 
                                                                                fontWeight: '500',
                                                                                color: '#2c3e50',
                                                                                marginBottom: '12px'
                                                                            }}>
                                                                                {(page - 1) * 10 + 1 + qIndex}. {item?.question?.question?.question_text}
                                                                            </h6>
                                                                            
                                                                            <div className="response-section" style={{
                                                                                backgroundColor: '#f8f9fa',
                                                                                padding: '12px',
                                                                                borderRadius: '6px',
                                                                                border: '1px solid #e9ecef'
                                                                            }}>
                                                                                <div className="d-flex align-items-center mb-2">
                                                                                    <span style={{ 
                                                                                        fontSize: '13px', 
                                                                                        color: '#6c757d',
                                                                                        marginRight: '8px'
                                                                                    }}>Response:</span>
                                                                                    <span className={`badge ${item?.question?.response?.value === "Yes" ? "badge-success" : 
                                                                                        item?.question?.response?.value === "No" ? "badge-danger" : "badge-secondary"}`}
                                                                                        style={{ 
                                                                                            padding: '6px 12px',
                                                                                            fontSize: '12px',
                                                                                            fontWeight: '500',
                                                                                            borderRadius: '4px'
                                                                                        }}>
                                                                                            {item?.question?.response?.value?.toUpperCase() || "N/A"}
                                                                                        </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <img
                                                                            src={humburger}
                                                                            onClick={() => {
                                                                                chatOpenBox(
                                                                                    item?.category?.categoryName,
                                                                                    item?.question?.question,
                                                                                    item?.category?.id
                                                                                )
                                                                            }}
                                                                            className="img-fluid cursor ml-3"
                                                                            alt="Menu"
                                                                            style={{ width: '24px', height: '24px' }}
                                                                        />
                                                                    </div>

                                                                    {item?.question?.question?.evidence == true && item?.question?.response?.evidences?.map((r, index) => {
                                                                        const filename = r?.fileKey?.split('/')?.pop()?.split('-')?.slice(-1)[0] || 'Download File';
                                                                        return (
                                                                            <div key={index} className="file-download-section" style={{ 
                                                                                maxWidth: 'fit-content',
                                                                                marginTop: '8px'
                                                                            }}>
                                                                                <a
                                                                                    href={r?.signedUrl}
                                                                                    target="_blank"
                                                                                    download={r?.signedUrl}
                                                                                    className="download-link"
                                                                                    style={{
                                                                                        display: 'inline-flex',
                                                                                        alignItems: 'center',
                                                                                        padding: '6px 12px',
                                                                                        backgroundColor: '#f8f9fa',
                                                                                        borderRadius: '4px',
                                                                                        color: '#2196f3',
                                                                                        textDecoration: 'none',
                                                                                        fontSize: '13px',
                                                                                        border: '1px solid #e9ecef'
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-paperclip mr-2"></i>
                                                                                    {filename}
                                                                                </a>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Chat Panel - Always Visible */}
                                    <div className="chat-panel" style={{
                                        width: '35%',
                                        marginLeft: '20px',
                                        backgroundColor: '#ffffff',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '8px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: 'fit-content'
                                    }}>
                                        <div className="chat-header" style={{
                                            padding: '12px 16px',
                                            borderBottom: '1px solid #e0e0e0',
                                            backgroundColor: '#f8f9fa',
                                            borderRadius: '8px 8px 0 0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}>
                                            <div className="d-flex align-items-center">
                                                <span className="mr-2">💬</span>
                                                <span style={{ fontSize: '14px', fontWeight: '500', color: '#2c3e50' }}>Follow-up Chat</span>
                                            </div>
                                        </div>

                                        <div className="chat-body" style={{ padding: '16px', flex: 1, overflowY: 'auto' }}>
                                            <div className="boxAccordian chatBoxMain">
                                                {messageAll?.map((r) => (
                                                    <div className={r?.type == "sent" ? "boxCChat" : "boxBChat"}
                                                        key={r?.id || r?.createdAt}
                                                        style={{
                                                            marginTop: '8px',
                                                            marginBottom: '8px',
                                                            padding: '12px',
                                                            borderRadius: '8px',
                                                            fontSize: '13px',
                                                            backgroundColor: r?.type == "sent" ? '#e3f2fd' : '#f5f5f5',
                                                            color: '#2c3e50',
                                                            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                                                        }}>
                                                        <p className="recieveMessage" style={{ margin: 0 }}>
                                                            {r?.messageText}
                                                        </p>
                                                        {r?.attachedFiles && (
                                                            <>
                                                                {r?.attachedFiles[0]?.fileType?.startsWith('image/') ? (
                                                                    <div className="chat-image-container mt-2">
                                                                        <img
                                                                            src={r?.attachedFiles[0]?.signedUrl}
                                                                            className="img-fluid imgChatSend"
                                                                            alt="chat attachment"
                                                                            onClick={() => setEnlargedImage(r?.attachedFiles[0]?.signedUrl)}
                                                                            style={{
                                                                                maxHeight: '120px',
                                                                                cursor: 'zoom-in',
                                                                                transition: 'transform 0.2s ease',
                                                                                border: '1px solid #e0e0e0',
                                                                                borderRadius: '4px'
                                                                            }}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div className="file-download-section mt-2">
                                                                        <a href={r?.attachedFiles[0]?.signedUrl}
                                                                            target="_blank"
                                                                            download={r?.attachedFiles[0]?.fileName}
                                                                            className="download-link"
                                                                            style={{
                                                                                display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                padding: '6px 12px',
                                                                                backgroundColor: '#f8f9fa',
                                                                                borderRadius: '4px',
                                                                                color: '#2196f3',
                                                                                textDecoration: 'none',
                                                                                fontSize: '13px',
                                                                                border: '1px solid #e9ecef'
                                                                            }}>
                                                                            <i className="fa fa-paperclip mr-2"></i>
                                                                            Download File
                                                                        </a>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                        <p className="recieveTime" style={{
                                                            margin: '4px 0 0 0',
                                                            fontSize: '11px',
                                                            color: '#6c757d'
                                                        }}>
                                                            {moment(r?.createdAt).format("DD-MM-YYYY || HH:mm")}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="chat-input" style={{
                                            borderTop: '1px solid #e0e0e0',
                                            padding: '12px',
                                            backgroundColor: '#f8f9fa',
                                            borderRadius: '0 0 8px 8px'
                                        }}>
                                            <div className="ReplyBox m-0">
                                                <div className="input-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
                                                    <input
                                                        placeholder="Type a message..."
                                                        value={messageInput}
                                                        onKeyDown={(e) => e.key === 'Enter' && sendMessages()}
                                                        onChange={(e) => setMessageInput(e.target.value)}
                                                        className="form-control"
                                                        style={{
                                                            fontSize: '13px',
                                                            height: '36px',
                                                            backgroundColor: '#ffffff',
                                                            border: '1px solid #e0e0e0',
                                                            color: '#2c3e50',
                                                            borderRadius: '18px',
                                                            paddingLeft: '15px'
                                                        }}
                                                    />
                                                    <div className="input-wrapper iconSend" style={{ marginLeft: '8px' }}>
                                                        <FontAwesomeIcon
                                                            icon={faFileUpload}
                                                            onClick={() => fileInputRef.current?.click()}
                                                            className="icon-attachment"
                                                            style={{ marginRight: '8px', cursor: 'pointer', color: '#2196f3' }}
                                                        />
                                                        <input
                                                            type="file"
                                                            ref={fileInputRef}
                                                            onChange={handleFileChange}
                                                            style={{ display: 'none' }}
                                                        />
                                                        <img src={sendButtonImg}
                                                            onClick={sendMessages}
                                                            alt="Send message"
                                                            style={{ cursor: 'pointer', width: '24px', height: '24px' }} />
                                                    </div>
                                                </div>
                                                {selectedFile && (
                                                    <div className="selected-file" style={{
                                                        fontSize: '12px',
                                                        padding: '8px 12px',
                                                        marginTop: '8px',
                                                        backgroundColor: '#f0f0f0',
                                                        borderRadius: '4px',
                                                        color: '#2c3e50',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between'
                                                    }}>
                                                        <span>{selectedFile.name}</span>
                                                        <button onClick={() => setSelectedFile(null)}
                                                            style={{
                                                                border: 'none',
                                                                background: 'none',
                                                                color: '#6c757d',
                                                                padding: '0 4px',
                                                                cursor: 'pointer',
                                                                fontSize: '16px'
                                                            }}>×</button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {enlargedImage && (
                        <div
                            className="modal-overlay"
                            onClick={() => setEnlargedImage(null)}
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 9999,
                                cursor: 'zoom-out'
                            }}
                        >
                            <div
                                className="modal-content"
                                style={{
                                    maxWidth: '90vw',
                                    maxHeight: '90vh',
                                    position: 'relative',
                                    backgroundColor: '#fff',
                                    padding: '15px',
                                    borderRadius: '8px',
                                    boxShadow: '0 5px 15px rgba(0,0,0,0.3)'
                                }}
                            >
                                <img
                                    src={enlargedImage}
                                    alt="Enlarged view"
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '85vh',
                                        objectFit: 'contain',
                                        borderRadius: '4px'
                                    }}
                                />
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setEnlargedImage(null);
                                    }}
                                    style={{
                                        position: 'absolute',
                                        top: '-15px',
                                        right: '-15px',
                                        background: '#fff',
                                        border: 'none',
                                        color: '#333',
                                        fontSize: '20px',
                                        cursor: 'pointer',
                                        padding: '5px',
                                        borderRadius: '50%',
                                        width: '30px',
                                        height: '30px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                                    }}
                                >
                                    ×
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {showConfirmModal && (
                <div className="modal fade Form-Wizard-modal d-block show">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="confirmModalLabel">
                                    {modalType === 'accept' ? 'Accept Risk' : 'Close Risk'}
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => setShowConfirmModal(false)}
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body pricing_page">
                                <div className="card mb-0">
                                    <div className="form-group mb-0">
                                        <label>
                                            Please provide a comment for this action:
                                        </label>
                                        <textarea
                                            rows="4"
                                            className="form-control"
                                            value={riskComment}
                                            onChange={(e) => setRiskComment(e.target.value)}
                                            placeholder="Enter your comment here..."
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-round btn-default"
                                    data-dismiss="modal"
                                    onClick={() => setShowConfirmModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${modalType === 'accept' ? 'btn-success' : 'btn-danger'}`}
                                    onClick={handleConfirmAction}
                                >
                                    Confirm {modalType === 'accept' ? 'Accept' : 'Close'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RiskRegisterChat;



